import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import useInputState from '../../hooks/useInputState';
import Form, { FORM_BUTTON_TYPES, FORM_INPUT_TYPES } from '../../ui-kit/Form';
import BuildingImage from '../../assets/images/Building.png';
import useTranslations from '../../hooks/useTranslations';
import { DICTIONARY } from '../../translations/dictionary';
import QuestionsForm from '../../components/QuestionsForm';

function Contact() {
  const { t } = useTranslations();

  return (
    <div className={styles.contact}>
      <div className={classNames('container')}>
        <div className={styles.contactInner}>
          <QuestionsForm
            title={t(DICTIONARY.contactUs)}
            subtitle={t(DICTIONARY.contactFormSubTitle)}
          />
        </div>
      </div>
    </div>
  );
}

export default Contact;
